import { render, staticRenderFns } from "./advert-contacts-popup.vue?vue&type=template&id=3306b656"
import script from "./advert-contacts-popup.vue?vue&type=script&lang=ts"
export * from "./advert-contacts-popup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports